import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk2() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`II.`}
            <br />
            {`Používateľský účet`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Na základe registrácie používateľa uskutočnenej na webovej stránke môže používateľ pristupovať do svojho používateľského rozhrania (ďalej len „používateľský účet“).`}</li>
            <li>{`Pri registrácii je používateľ povinný uvádzať správne a pravdivo všetky údaje. Údaje uvedené v používateľskom účte je používateľ pri akejkoľvek ich zmene povinný aktualizovať. Údaje uvedené používateľom v používateľskom účte sú poskytovateľom považované za správne.`}</li>
            <li>{`Prístup k používateľskému účtu je zabezpečený používateľským menom a heslom. Používateľ je povinný zachovávať mlčanlivosť týkajúcu sa informácií nutných k prístupu do jeho používateľského účtu.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Používateľ nie je oprávnený umožniť využívanie používateľského účtu tretím osobám.`}</li>
            <li>{`Používateľ berie na vedomie, že používateľský účet nemusí byť dostupný nepretržito, a to najmä s prihliadnutím na nutnú údržbu hardvérového a softvérového vybavenia poskytovateľa, popr. nutnú údržbu hardvérového a softvérového vybavenia tretích osôb.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk2;
